import { Component, Input } from "@angular/core";
import { Global } from "../../global";

@Component({
  selector: 'pdf-viewer',
  template: `<iframe name="iframePdf" id="iframePdf" [src]="fullUrl | safe" [style]="'border: '+border+'; '+css | safe:'style'"></iframe>`
})

export class PdfViewerComponent {

  @Input()
  url: string = '';

  @Input()
  css: string = 'width:100%; height:100%';

  @Input()
  border: string = 'none';

  constructor(public global: Global) { }

  get fullUrl() {
    if (!this.url) {
      return '';
    }
    return this.global.dominio_site_painel + '/assets/lib/pdfjs/web/viewer.html?file=' + encodeURIComponent(this.url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pdf-viewer.component.ts